export const SYSTEM_SERVER_INFO = 'SYSTEM_SERVER_INFO';
